'use strict';

var carouselBannerSlider = () => {
    $('.carousel-banner-slider').slick();
};

$(document).ready(function () {
    carouselBannerSlider();
});
